"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _models = require("@seedlang/models");
var _mobx = require("mobx");
var _layouts = require("@seedlang/layouts");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var OverlayUI = (_class = /*#__PURE__*/function (_RootState) {
  function OverlayUI() {
    var _this;
    _classCallCheck(this, OverlayUI);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, OverlayUI, [].concat(args));
    _initializerDefineProperty(_this, "overlays", _descriptor, _this);
    _initializerDefineProperty(_this, "addOverlay", _descriptor2, _this);
    _initializerDefineProperty(_this, "removeOverlay", _descriptor3, _this);
    _initializerDefineProperty(_this, "clearOverlays", _descriptor4, _this);
    _initializerDefineProperty(_this, "setOverlays", _descriptor5, _this);
    _initializerDefineProperty(_this, "hasOverlay", _descriptor6, _this);
    _initializerDefineProperty(_this, "getOverlay", _descriptor7, _this);
    _initializerDefineProperty(_this, "removeOverlays", _descriptor8, _this);
    return _this;
  }
  _inherits(OverlayUI, _RootState);
  return _createClass(OverlayUI, [{
    key: "hasOverlays",
    get: function get() {
      return this.overlays.length > 0;
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "overlays", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "hasOverlays", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasOverlays"), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "addOverlay", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function (name) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!props.allowDuplicates && _this2.hasOverlay(name)) {
        return;
      }
      var layout = new _layouts.OverlayLayout(props);
      props = Object.assign({
        layout: layout,
        overlayId: (0, _utils.createUuid)(),
        params: {}
      }, props);
      var overlayState = new _models.OverlayState(_this2, props);
      _this2.overlays.push({
        name: name,
        props: props,
        overlayState: overlayState
      });
      overlayState.set('isOpen', true);
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "removeOverlay", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (name) {
      (0, _lodash.each)(_this3.overlays.filter(function (item) {
        return item.name === name;
      }), function (overlay) {
        overlay.overlayState.removeOverlay();
      });
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "clearOverlays", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function () {
      _this4.overlays = [];
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "setOverlays", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function (overlays) {
      _this5.overlays = overlays;
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasOverlay", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function (overlayName) {
      var _this6$getOverlay$ove;
      return (0, _utils.isPresent)(_this6.getOverlay(overlayName)) && ((_this6$getOverlay$ove = _this6.getOverlay(overlayName).overlayState) === null || _this6$getOverlay$ove === void 0 ? void 0 : _this6$getOverlay$ove.isOpen);
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "getOverlay", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;
    return function (overlayName) {
      return _this7.overlays.find(function (item) {
        return item.name === overlayName;
      });
    };
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "removeOverlays", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function (ary) {
      (0, _lodash.each)(ary, function (name) {
        _this8.removeOverlay(name);
      });
    };
  }
}), _class);
var _default = exports["default"] = new OverlayUI();